<template>
  <div :class="['monito_score',getColorScore(score)]">
    <svg class="progress-ring" :height=width :width=width>
      <circle
   			stroke="#D2D1D270"
        :stroke-width=stroke
    		fill="transparent"
    		:r=half(width)-stroke
    		:cx=half(width)
    		:cy=half(width) />
        	<circle
    		class="progress-ring-circle"
   			stroke="#f00"
   			:style="'strokeDasharray: '+  getMonitoScore(score) +' '+ Math.round(2 * Math.PI * (half(width) - stroke)) +''"
    		:stroke-width=stroke
    		fill="transparent"
    		:r=half(width)-stroke
    		:cx=half(width)
        :cy=half(width)
      />
    </svg>
    <span class="score f-anti" :style="'fontSize:'+size+'px'">{{ score }} </span>
  </div>
</template>

<script>
  export default {
   
    props: ['score', 'width', 'stroke','size'],
    methods: {
      getColorScore(score){
        if(score >= '8.0'){
          return 'excellent';
        } else if(score >= '7.0'){
          return 'good';
        } else if(score >= '6.5'){
          return 'average';
        } else if(score >= '5.0'){
          return 'poor';
        } else {
          return 'bad';
        }
      },
      half(nombre){
        return nombre/2;
      },
      getMonitoScore(score){
        var value = (score * 10) * (Math.round(2 * Math.PI * (this.half(this.width) - this.stroke))/100);
        return value;
      }
    }
  }
</script>
<style lang="scss" scoped>
.monito_score {
    transform: scale(1.2);
    width: 58px;
    height: 49px;
    margin-left: 7px;
    margin-right: 25px;
    position: relative;

    svg {
      position: absolute;
      top: -2px;
      left: -2px;
    }

    .score {
      display: inline-block;
      width: 52px;
      padding-top: 17px;
      left: 0px;
      position: relative;
      box-sizing: border-box;
      height: 52px;
      text-align: center;
      font-family:Avenir Next,-apple-system,system-ui,Segoe UI,Roboto,Ubuntu,Cantarell,Noto Sans,sans-serif,BlinkMacSystemFont,Helvetica Neue,Arial;
      font-weight: 700;

    }
  }


  .progress-ring-circle {

    
    transform: rotate(-90deg);
      transform-origin: 50% 50%;
      stroke: black;

  }

  .monito_score {
    
    &.excellent {
      color: #00a000;
      .progress-ring-circle {
        stroke: #00a000;
      }
    }
    &.good {
      color: #76c107;
      .progress-ring-circle {
        stroke: #76c107;
      }
    }
    &.average {
      color: #FF9A0A;
      .progress-ring-circle {
        stroke: #FF9A0A;
      }
    }
    &.poor {
      color: #FF5B05;
      .progress-ring-circle {
        stroke: #FF5B05;
      }
    }
    &.bad {
      color: #F5313E;
      .progress-ring-circle {
        stroke: #F5313E;
      }
    }
  }

  </style>


// WEBPACK FOOTER //
// src/components/CircleScore.vue